import React from 'react';
import { PlaylistSpecialBoard } from './PlaylistSpecialBoard';

/**
 * Cabina de Sonido y Panel de Control DJ - Dinámica "Arma la Playlist" (Tile ID 46).
 * Envoltorio principal que renderiza la consola completa PlaylistSpecialBoard.
 * Ruta: /admin/playlist/cabina
 * 
 * @component PlaylistCabin
 * @param {Object} props
 * @param {Function} [props.getOutOfTheDynamic] - Callback para salir al dashboard.
 */
export const PlaylistCabin = ({ getOutOfTheDynamic }) => {
    return <PlaylistSpecialBoard getOutOfTheDynamic={getOutOfTheDynamic} />;
};

export { PlaylistSpecialBoard };
export default PlaylistCabin;
